import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BaseService } from 'src/app/core/services/base.service';
import { HelperService } from 'src/app/core/services/helper.service';
import { OiGroupDialogData, OiGroupProcessDialogComponent } from 'src/app/shared/oi-group-process-dialog/oi-group-process-dialog.component';

@Component({
  selector: 'app-invoice-transfer-credit-to-deposit',
  templateUrl: './invoice-transfer-credit-to-deposit.component.html',
  styleUrls: ['./invoice-transfer-credit-to-deposit.component.scss']
})
export class InvoiceTransferCreditToDepositComponent implements OnInit {
  mode: string = 'SEARCH';
  stores: any[] = [];
  searchForm: FormGroup;
  form: FormGroup;

  validateResponse: any = null;

  busy: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<InvoiceTransferCreditToDepositComponent>,
    public fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: {
      invoiceNumber: string;
      customerCode: string;
    },
    private baseService: BaseService,
    private dialog: MatDialog,
    private helperService: HelperService,
  ) {
    console.log('data', data);
    this.searchForm = fb.group({
      fromInvoiceNumber: [data.invoiceNumber, Validators.compose([Validators.required])],
      fromCustomerCode: [data.customerCode, Validators.compose([Validators.required])],
      toSalesOrderNumber: [null, Validators.compose([Validators.required])],
      storeId: [null, Validators.compose([Validators.required])]
    });

    this.form = fb.group({
      fromInvoiceNumber: [null, Validators.compose([Validators.required])],
      fromCustomerCode: [null, Validators.compose([Validators.required])],
      toSalesOrderNumber: [null, Validators.compose([Validators.required])],
      storeId: [null, Validators.compose([Validators.required])],
      amountToTransfer: [null, Validators.compose([Validators.required])],
      approvedByEmail: [null, Validators.compose([Validators.required])],
      approvedByPwd: [null, Validators.compose([Validators.required])],
    });

    this.searchForm.controls['fromInvoiceNumber'].disable();
    this.searchForm.controls['fromCustomerCode'].disable();
    // this.searchForm.controls['storeId'].setValue(this.stores[0].storeId);
  }

  ngOnInit() {
    this.baseService.executeCommand<any>('portal_syspro_invoice_transfer_credit_to_deposit_dialog_config', this.searchForm.getRawValue())
      .subscribe(response => {
        if (response.responseCode === 0) {
          this.stores = response.data.stores;
          if (this.stores && this.stores.length === 1) {
            this.searchForm.controls['storeId'].setValue(this.stores[0].storeId);
          }
        }
      });
  }

  setBusy(isBusy: boolean) {
    this.busy = isBusy;
    if (isBusy) {
      this.searchForm.disable();
      this.form.disable();
    } else {
      this.searchForm.enable();
      this.form.enable();
      this.searchForm.controls['fromInvoiceNumber'].disable();
      this.searchForm.controls['fromCustomerCode'].disable();
    }
  }
  validate() {
    this.form.reset();
    this.setBusy(true);
    this.validateResponse = null;
    this.baseService.executeCommand<any>('portal_syspro_invoice_transfer_credit_to_deposit_dialog_validate', this.searchForm.getRawValue())
      .subscribe(
        response => {
          if (response.responseCode === 0) {
            this.validateResponse = response.data;
            if (this.validateResponse.transferAlllowed) {
              this.form.patchValue(this.searchForm.value);
              this.form.controls['amountToTransfer'].setValue(this.validateResponse.maxTransferAmount);
              this.form.controls['amountToTransfer'].setValidators(Validators.compose([Validators.required, Validators.min(0.01), Validators.max(this.validateResponse.maxTransferAmount)]));
            }
          }
          this.setBusy(false);
        }),
      error => {
        this.setBusy(false);
      };
  }

  save() {
    let body = this.form.getRawValue();
    body.approvedByPwd = this.helperService.hash(body.approvedByPwd);

    const dialogData: OiGroupDialogData = {
      title: 'Transfering Credit to Deposit',
      function: 'portal_oi_group_invoice_transfer_credit_to_deposit',
      postBody: body
    };


    const ref = this.dialog.open(OiGroupProcessDialogComponent, {
      data: dialogData,
      width: '450px'
    });

    ref.afterClosed().subscribe(oiResult => {
      if (oiResult.responseCode === 0 && oiResult.data && oiResult.data.groupProcessedSuccessfully === true) {
        this.dialogRef.close(true);
      } else {
        this.validate();

      }
    });

  }

}
